import type { FC, ReactNode } from 'react'

import { useEffect, useState } from 'react'

const ReadingProgress: FC<{ targetId: string }> = ({ targetId }): ReactNode => {
    const [progress, setProgress] = useState(0)

    useEffect(() => {
        const update = () => {
            const target = document.getElementById(targetId)
            if (!target) return

            const rect = target.getBoundingClientRect()
            const total = rect.height - window.innerHeight
            const read = Math.min(Math.max(-rect.top, 0), Math.max(total, 1))

            setProgress(total > 0 ? read / total : 1)
        }

        update()
        window.addEventListener('scroll', update, { passive: true })
        window.addEventListener('resize', update)

        return () => {
            window.removeEventListener('scroll', update)
            window.removeEventListener('resize', update)
        }
    }, [targetId])

    return (
        <div
            aria-hidden='true'
            className='fixed inset-x-0 top-0 z-50 h-0.5 bg-transparent'
        >
            <div
                className='h-full origin-left bg-primary transition-transform duration-150 ease-out'
                style={{ transform: `scaleX(${progress})` }}
            />
        </div>
    )
}

export default ReadingProgress
